import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Suspense } from 'react';
import Splash from '../Components/Routes/Splash';
const Loader = ({ children }) => {
    const fallBack = _jsx(Splash, {});
    return _jsx(Suspense, Object.assign({ fallback: fallBack }, { children: children }));
};
export function withLoader(Component) {
    return (props) => _jsx(Loader, { children: _jsx(Component, Object.assign({}, props)) });
}
